import React from 'react';
import { withTranslation } from '../../ChildrenContext.js';
import PropTypes from 'prop-types';
import PaymentPageContainerComponent from './PaymentPageContainer/PaymentPageContainer.container';

const PaymentPage = ({ t }) => {
    const staticNames = t?.paymentPage || {};

    return (
        <React.Fragment>
            <div className="page-heading">
                <div className="page-heading__inner">
                    <h2>{staticNames.title}</h2>
                </div>
            </div>

            <section className="wrapper-content">
                <PaymentPageContainerComponent />
            </section>
        </React.Fragment>
    );
};

PaymentPage.propTypes = {
    t: PropTypes.object
};

PaymentPage.defaultProps = {
    t: {}
};

export default withTranslation(PaymentPage);
